import React from "react"
import { Button, useMantineTheme } from "@mantine/core"

import { Icon } from "@/components/Icon"
import classes from "./EmptyScreen.module.css"

interface EmptyScreenProps {
    buttonText?: string
    buttonOnClick?: () => void
    icon: string
    iconFamily: string
    message: string
    title: string
}

export const EmptyScreen = ({ buttonText, buttonOnClick, icon, iconFamily, message, title }: EmptyScreenProps) => {
    const theme = useMantineTheme()

    return (
        <div className={classes.layout}>
            <Icon
                ariaLabel="comment icon"
                className={classes.icon}
                color={theme.colors.violet[5]}
                icon={icon}
                iconFamily={iconFamily}
                size="2x"
            />
            <div className={classes.text}>
                <span className={classes.title}>{title}</span>
                <span className={classes.message}>{message}</span>
            </div>
            {buttonText && (
                <Button
                    className={classes.button}
                    leftIcon={<Icon icon="plus" />}
                    onClick={() => buttonOnClick()}
                    variant="outline"
                >
                    {buttonText}
                </Button>
            )}
        </div>
    )
}
